



























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HowToNav extends Vue {
  @Prop() private section?: string;
}
